<div class='full-form'>
  @if (assistantPricingLocked) {
    <assistant-managed-banner></assistant-managed-banner>
  }
  @if (filterFormGroup) {
    <form autocomplete="off" name='form' [formGroup]="filterFormGroup" [class.prices-locked]="assistantPricingLocked" class="fx-column fx-justify-start fx-items-stretch fx-lt-lg-justify-stretch fx-lt-lg-items-stretch">
      <div class="pricing-categories">
        <div class="instruction">
          <p class="instruction">
            Prezzo per gruppo significa che i clienti pagano un prezzo per l'intero gruppo. Questo è spesso per attività private. Il prezzo a persona ti consente di offrire prezzi diversi per adulti, adolescenti, bambini, ecc. Utilizzalo per attività pubbliche. Se hai bisogno sia del Prezzo per gruppo che del Prezzo per persona, inizia con uno di questi, invia la tua attività affinché il nostro team possa rivedere, quindi crea una nuova opzione.
          </p>
        </div>
      </div>
      @if ((datasetRS.record.value.trip_service_rule_type == "0")) {
        <div class="base-dropdown age-group-selection-menu">
          <button class="age-range-btn" mat-button [matMenuTriggerFor]="menu">
            Aggiungi fascia d'età
            <mat-icon>keyboard_arrow_down</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            @if (buttons["CHD"]) {
              <button mat-menu-item (click)='buildForm("CHD")'>CHILDREN</button>
            }
            @if (buttons["INF"]) {
              <button mat-menu-item (click)='buildForm("INF")'>INFANT</button>
            }
            @if (buttons["SNR"]) {
              <button mat-menu-item (click)='buildForm("SNR")'>SENIOR</button>
            }
          </mat-menu>
        </div>
      }
      @if (datasetACS.loading.value) {
        <mat-progress-bar class='mt-24 mb-24' mode="indeterminate"></mat-progress-bar>
      }
      @for (key of priceServicesCollection | customKeys; track key) {
        <section class="price-block-category">
          <h3 class="price-block-title">
            <span class="title">{{priceServicesCollection[key].title}}</span>
            <div class="price-block-actions">
              @if (priceServicesCollection[key].canBeRemoved) {
                <button class="gyg-button gyg-button-medium gyg-button-link-error remove-pricing-category-btn" (click)='removePriceService(priceServicesCollection[key])'>
                  Rimuovi
                </button>
              }
            </div>
          </h3>
          @if (canShowAge()) {
            <div class="age-range">
              <div class="age-from">
                {{priceServicesCollection[key].age.from}}
              </div>
              <div class="separator">-</div>
              <div class="age-to">
                <form-input-viewer
                  [formInputDefinition]='fileterFields.get(priceServicesCollection[key].age.field)'
                  [formGroup]='filterFormGroup'
                  [formControlKey]='priceServicesCollection[key].age.field'
                ></form-input-viewer>
              </div>
            </div>
          }
          <div [formArrayName]='priceServicesCollection[key].formArrayName'>
            @for (controlFormGroup of filterFormGroup.get(priceServicesCollection[key].formArrayName)['controls']; track controlFormGroup; let first = $first; let i = $index) {
              <div class="row">
                <div class="price-block-cols">
                  <div class="price-block-age">
                    <form-input-viewer
                      [formInputDefinition]='fileterFields.get("price")'
                      [formGroup]='controlFormGroup'
                      [formControlKey]='"price"'
                    ></form-input-viewer>
                  </div>
                  <div class="price-block-pricing">
                    <form-input-viewer
                      [formInputDefinition]='fileterFields.get("option_id")'
                      [formGroup]='controlFormGroup'
                      [formControlKey]='"option_id"'
                      [dataContainerService]='datasetACS'
                    ></form-input-viewer>
                  </div>
                </div>
                <div class="dates-block-cols">
                  <div class="valid_from">
                    <form-input-viewer
                      [formInputDefinition]='fileterFields.get("valid_from")'
                      [formGroup]='controlFormGroup'
                      [formControlKey]='"valid_from"'
                    ></form-input-viewer>
                  </div>
                  <div class="valid_to">
                    <form-input-viewer
                      [formInputDefinition]='fileterFields.get("valid_to")'
                      [formGroup]='controlFormGroup'
                      [formControlKey]='"valid_to"'
                    ></form-input-viewer>
                  </div>
                </div>
                @if (!first) {
                  <div class="delete-block">
                    <mat-icon (click)='removePriceRule(priceServicesCollection[key], i)'>delete</mat-icon>
                  </div>
                }
              </div>
            }
          </div>
          <div class="set-up-price-tiers" (click)='setUpPriceTiers(priceServicesCollection[key].code)'>
            <b>Aggiungi prezzo</b>
          </div>
        </section>
      }
      @if (customServices.length) {
        <section class="price-block-category custom-criteria" aria-labelledby="custom-criteria-title">
          <h3 class="price-block-title" id="custom-criteria-title">
            <span class="title">Altri criteri</span>
          </h3>
          <p class="custom-criteria__hint">
            Usano una regola su misura (per esempio un supplemento oltre un certo numero di persone): si sommano alle
            categorie qui sopra e si modificano con l'assistente AI. Salvare questa pagina non li cambia.
          </p>
          @for (service of customServices; track service.code) {
            <article class="custom-criterion">
              <header class="custom-criterion__head">
                <span class="custom-criterion__title">{{ service.title }}</span>
                @if (service.rule_description) {
                  <span class="custom-criterion__rule">{{ service.rule_description }}</span>
                }
              </header>
              <p class="custom-criterion__formula">
                Si applica quando <code>{{ service.condition_rule }}</code>, il prezzo conta <code>{{ service.count_rule }}</code> volte
              </p>
              @if (service.price_rules?.length) {
                <ul class="custom-criterion__prices">
                  @for (rule of service.price_rules; track $index) {
                    <li>
                      <span class="custom-criterion__period">
                        Dal {{ rule.valid_from | date:'dd/MM/yyyy' }}{{ rule.valid_to ? ' al ' + (rule.valid_to | date:'dd/MM/yyyy') : ', senza scadenza' }}
                      </span>
                      <span class="custom-criterion__price">{{ formatPrice(rule.price) }}</span>
                    </li>
                  }
                </ul>
              } @else {
                <p class="custom-criterion__empty">Nessun prezzo: finché manca, le prenotazioni a cui si applica non si possono fare.</p>
              }
            </article>
          }
        </section>
      }
      @if (!assistantPricingLocked) {
      <div class="save-button-container">
        <button
          [disabled]='isDisabledButton()'
          class="gyg-button gyg-button-medium gyg-button-cta-light"
          (click)='onSave()'>
          <span>Salva e continua</span>
        </button>
      </div>
      }
    </form>
  }

</div>